export type SpotlightTileLayout = {
  isSpotlight: boolean
  gridColumn: string | null
}

/**
 * Mosaic layout: 10-tile repeating cycle in a 3-column grid.
 * Indices 0 and 6 in each cycle are wide (span 2), the rest are single-column.
 * The 1st tile is always wide-left.
 */
export const getSpotlightTileLayouts = (
  count: number,
  isMobile: boolean,
): SpotlightTileLayout[] => {
  if (count === 0 || isMobile) {
    return Array.from({ length: count }, (): SpotlightTileLayout => ({
      isSpotlight: false,
      gridColumn: null,
    }))
  }

  return Array.from({ length: count }, (_, index): SpotlightTileLayout => {
    const cycle = index % 10
    const isWideLeft = cycle === 0
    const isWideRight = cycle === 6
    const isSpotlight = isWideLeft || isWideRight
    return {
      isSpotlight,
      gridColumn: isWideLeft
        ? '1 / span 2'
        : isWideRight
          ? '2 / span 2'
          : null,
    }
  })
}
